export class SiloRealCredentials {
  username: string;
  password: string;
}
